var map = {
	"./BMBF.png": "7370",
	"./BMEL.png": "ed0f",
	"./BadenCampus.png": "0a9f",
	"./ESF-BW-Logo.jpg": "b2bb",
	"./ESF-EU-Logo.jpg": "86ae",
	"./Life-Science-Accelerator.png": "2a15",
	"./Start-Up-BW-Accelerator.png": "300c",
	"./invest.png": "0b99",
	"./investBW.png": "dd1a",
	"./l-bank.jpg": "9236"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "7338";